<script>
import moment from 'moment';
import Layout from "../../layouts/main";
import 'vue2-datepicker/locale/pt-br';
import appConfig from "@/app.config";

import CustomerService from '@/services/customer';
import CompanyService from '@/services/company';

moment.locale('pt-BR');

export default {
  page: {
    title: "Listagem de Clientes",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
  data() {
    return {
      title: "Listagem de Clientes",
      loading: false,
      customers: [],
      customer: {},
      companies: [],
      showModal: false,
      showCompanyModal: false,
      searchParams: {
        customer: '',
      },
      searchEmptyField: false,

      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      fields: [
        { key: 'code', sortable: true, label: 'Código' },
        { key: 'name', sortable: true, label: 'Razão Social' },
        { key: 'documentNumber', sortable: true, label: 'CNPJ' },
        { key: 'saleDate', sortable: true, label: 'Última Compra' },
        { key: 'actions', label: 'Ações', class: 'nowrap-col' }
      ],
    };
  },
  mounted() {
    this.search();

    CompanyService.getAll().then((res) => {
      this.companies = res.data;
    })
  },
  methods: {
    search() {
      this.searchEmptyField = false;
      this.loadCustomers();
    },
    loadCustomers(page = 1, showLoading = true) {
      if (showLoading) {
        this.loading = true;
      }

      CustomerService.getList(page, this.searchParams.customer)
        .then(res => {
          this.loading = false;

          this.customers = res.data.customers;
          this.count = res.data.count;
          this.currentCount = res.data.currentCount;
          this.currentPage = res.data.currentPage;
          this.totalPages = res.data.totalPages;
          this.perPage = res.data.perPage;
          this.startIndex = res.data.startIndex;
          this.endIndex = res.data.endIndex;
        })
      .catch(() => {
        this.loading = false;
      })
    },
    onPageChange() {
      window.scrollTo(0,0);
      this.loadCustomers(this.currentPage);
    },
    showDetails() {

    },
    exportData() {
      this.loading = true;

      CustomerService.exportCustomers(this.searchParams.customer).then(res => {
        this.loading = false;
        
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');

        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'ListagemClientes.xlsx');
        document.body.appendChild(fileLink);

        fileLink.click();
      }).catch(() => {
        this.loading = false;
      })
    },
    details(customer) {
      this.customer = customer;
      this.showModal = true;
    },
    openCompanySelect(customer) {
      this.customer = customer;
      this.showCompanyModal = true;
    },
    selectCompany(companyId) {
      this.$store.dispatch('CUSTOMER_PRICE', { companyId, customerId: this.customer._id });
      this.showCompanyModal = false;

      this.$router.push('/reports/customer-prices');
    },
    openCustomerTablePrice(customer) {
      this.$store.dispatch('CUSTOMER_PRICE', { customerId: customer._id });
      this.$router.push('/reports/customer-prices-atacarejo');
    },
    changeSearch() {
      if (this.searchParams.customer === '' && !this.searchEmptyField) {
        this.searchEmptyField = true;
        this.loadCustomers(1, true);
      }
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="search" class="align-items-center">
              <div class="row">
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Busca</label>
                    <input
                      type="text"
                      v-model="searchParams.customer"
                      class="form-control"
                      placeholder="Razão Social, Fantasia, Código ou CNPJ"
                      v-on:keyup="changeSearch"
                    />
                  </div>
                </div>
              </div>

              <div class="button-search">
                <b-button type="submit" variant="primary" v-if="!loading">Filtrar</b-button>
                <b-button class="ml-2" variant="outline-primary" @click="exportData" v-if="!loading">Exportar</b-button>
                <a href="javascript:void(0);" class="text-primary" v-if="loading">
                  <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body"> 
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="customers"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
                <template v-slot:cell(name)="row">
                  <span :class=" { 'text-success': (row.item.customerType === 'C') }">{{row.item.name}}</span>
                </template>

                <template v-slot:cell(statusDescription)="row">
                  <span
                    class="badge badge-pill badge-soft-primary font-size-12"
                  >{{row.item.statusDescription}}</span>
                </template>
                
                <template v-slot:cell(actions)="row">
                  <a href="javascript:void(0);" v-b-tooltip.hover.top title="Dados do Cliente" class="action-icon text-success mr-3" @click="details(row.item)">
                    <i class="mdi mdi-eye font-size-18"></i>
                  </a>

                  <a href="javascript:void(0);" v-b-tooltip.hover.top title="Tabela de Preço" class="action-icon text-primary mr-3" @click="openCompanySelect(row.item)">
                    <i class="mdi mdi-table font-size-18"></i>
                  </a>

                  <a href="javascript:void(0);" v-b-tooltip.hover.top title="Tabela ATACAREJO" class="action-icon text-warning mr-3" @click="openCustomerTablePrice(row.item)">
                    <i class="mdi mdi-table font-size-18"></i>
                  </a>
                </template>
              </b-table>
            </div>
          </div>
        </div>

        <div class="row justify-content-md-between align-items-md-center mt-4">
          <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>

          <div class="col-xl-5">
            <div class="text-md-right float-xl-right mt-2 pagination-rounded">
              <b-pagination
                v-model="currentPage" 
                :total-rows="count"
                :per-page="perPage"
                @input="onPageChange"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="showModal" title="Detalhes do Cliente" centered>
      <div class="customer-detail">
        <div class="field">
          <p class="title">Código do Cliente:</p>
          <p>{{customer.code}}</p>
        </div>
        <div class="field">
          <p class="title">Fantasia:</p>
          <p>{{customer.companyName}}</p>
        </div>
        <div class="field">
          <p class="title">Razão Social:</p>
          <p>{{customer.name}}</p>
        </div>
        <div class="field">
          <p class="title">CPF/CNPJ:</p>
          <p>{{customer.documentNumber}}</p>
        </div>
        <div class="field">
          <p class="title">Endereço:</p>
          <p>{{customer.street}}</p>
        </div>
        <div class="field">
          <p class="title">Bairro:</p>
          <p>{{customer.district}}</p>
        </div>
        <div class="field">
          <p class="title">Cidade/UF:</p>
          <p>{{customer.city}}/{{customer.state}}</p>
        </div>
        <div class="field">
          <p class="title">CEP:</p>
          <p>{{customer.zipcode}}</p>
        </div>
        <div class="field">
          <p class="title">Telefone:</p>
          <p>{{customer.phoneNumber}}</p>
        </div>
        <div class="field">
          <p class="title">E-mail:</p>
          <p>{{customer.email}}</p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="showModal = false">Fechar</b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showCompanyModal"
      centered
      title="Selecionar Filial"
      hide-footer
    >
      <b-button
        v-for="company in companies"
        :key="company._id"
        size="lg"
        block
        variant="light"
        @click="selectCompany(company._id)"
      >
        {{company.code}} - {{company.name}}
      </b-button>
    </b-modal>
  </Layout>
</template>


<style lang="scss">
  .button-search {
    display: flex;
    align-items: center;
  }

  .nowrap-col {
    white-space: nowrap;
  }

  .customer-detail {
    .field {
      display: flex;
      flex-direction: row;

      p {
        margin-bottom: 8px;

        &.title {
          font-weight: 600;
          color: #000;
          margin-right: 16px;
        }
      }
    }
  }
</style>